import React from 'react';
import { gql } from '@apollo/client';
import { Show, SimpleShowLayout, TextField } from 'react-admin';
import TimestampFields from 'components/TimestampFields';

const Location_positionsShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField label="ID" source="id" />
      <TextField label="Position" source="position.display_name" />
      <TimestampFields />
    </SimpleShowLayout>
  </Show>
);

Location_positionsShow.query = gql`
  query GET_ONE($id: Int!) {
    locationPosition(id: $id) {
      id
      position {
        id
        display_name
      }
    }
  }
`;

export default Location_positionsShow;
